module.exports = __webpack_public_path__ + "media/images/ac_templates/201/rpkht-b16b2e77afaf0414f07f00dafd29a4ac.jpg";